import SearchNominatim from 'ol-ext/control/SearchNominatim';
import Select from 'ol/interaction/Select';

export var select = new Select({
  style:null,
});


export var searchNominatim = new SearchNominatim({
  target: $("#searchNominatim").get(0),
  polygon: false,
  reverse: false,
  position: false,	// Search, with priority to geo position
  //target: document.querySelector('#searchNominatim'),
  //typing: 1,
  //minLength:3,
  maxItems: 100,
  placeholder: "Szukaj...",
  url: "https://nominatim.openstreetmap.org/search",
});

searchNominatim.clearHistory();